import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setSignInOverlayIsOpen from "@insite/client-framework/Store/Components/SignInOverlay/Handlers/SetSignInOverlayIsOpen";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    return {
        hoursLeft: state.context.settings.settingsCollection.totalHoursLeftForSameDayShipping || "",
    };
};

const mapDispatchToProps = {
    setSignInOverlayIsOpen,
};

export interface sameDayStyles {
    sameDayWrapper?: InjectableCss;
    sameDayTimerText?: InjectableCss;
    timeRemaning?: InjectableCss;
}

export const sameDayStyles: sameDayStyles = {
    sameDayWrapper: {
        css: css`
            display: flex;
            gap: 6px;
            padding: 10px 0 10px 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: block;
                        font-size: 12px;
                        padding: 0;
                        min-width: 140px;
                    `,
                    css`
                        display: block;
                        font-size: 12px;
                        padding: 0;
                        min-width: 140px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    sameDayTimerText: {
        css: css`
            color: #ffff;
            font-size: 15.5px;
            padding: 0 1em;
            text-transform: none;
            height: 40px;
            line-height: 40px;
            font-weight: 600;
            letter-spacing: -0.5px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0;
                        line-height: 0;
                    `,
                    css`
                        padding: 0;
                        line-height: 0;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    timeRemaning: {
        css: css`
            color: #ffff;
            font-size: 15.5px;
            padding: 0px;
            margin-right: 40px;
            text-transform: none;
            height: 40px;
            line-height: 40px;
            font-weight: 600;
            letter-spacing: -0.5px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-right: 0px;
                        margin-left: 4px;
                    `,
                    css`
                        margin-right: 0px;
                        margin-left: 4px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
};

type Props = WidgetProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasHistory &
    ThemeProps<BaseTheme>;

export const SameDayShippingTimer: FC<Props> = ({ hoursLeft }: Props) => {
    if (!hoursLeft) {
        return null;
    }

    const [timer, setTimer] = useState("");

    const leftHourConveter = (leftHour: any) => {
        leftHour = leftHour.split(":");
        return {
            // eslint-disable-next-line radix
            hour: parseInt(leftHour[0]),
            // eslint-disable-next-line radix
            min: parseInt(leftHour[1]),
        };
    };

    const getSettingWithCounter = () => {
        if (hoursLeft) {
            const test = leftHourConveter(hoursLeft);
            const newDate = new Date();
            newDate.setHours(newDate.getHours() + test.hour);
            newDate.setMinutes(newDate.getMinutes() + test.min);
            const countDownDate = newDate.getTime();
            const nextCountDownDate = new Date();
            nextCountDownDate.setDate(nextCountDownDate.getDate() + 1);
            const timerInterval = setInterval(() => {
                getCountdown(countDownDate, nextCountDownDate);
                // this.$scope.$apply(); // Trigger a digest cycle to update the view
            }, 1000);

            return timerInterval;
        }
    };

    useEffect(() => {
        getSettingWithCounter();
    }, []);

    const getCountdown = (countDownDate: number, nextCountDownDate: Date) => {
        const now = new Date().getTime();
        const distance = countDownDate - now;

        if (distance <= 0) {
            countDownDate = nextCountDownDate.getTime();
            return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        const timer: any = `${hours}h ${minutes}m ${seconds}s `;
        setTimer(timer);
    };
    const styles = sameDayStyles;

    return (
        <StyledWrapper {...styles.sameDayWrapper}>
            <Typography {...styles.sameDayTimerText}>{translate("SHIPS TODAY")}</Typography>
            <Typography {...styles.timeRemaning}>{timer}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(withTheme(SameDayShippingTimer))),
    definition: {
        displayName: "Same Day Shipping Timmer",
        group: "Common",
    },
};

export default widgetModule;
